import { useMemo } from "react";

const TEAM_COLORS = [
  "#FF6B6B", 
  "#4D96FF", 
  "#6BCB77", 
  "#FFD93D", 
];

export function useTeamIdToColor(teamIds: number[] = []) {
  return useMemo(() => {
    const uniqueIds = Array.from(new Set(teamIds)).filter(Boolean);
    uniqueIds.sort((a, b) => a - b);

    return uniqueIds.reduce((acc, id, index) => {
      acc[id] = TEAM_COLORS[index % TEAM_COLORS.length];
      return acc;
    }, {} as Record<number, string>);
  }, [teamIds]);
}
